import { render, staticRenderFns } from "./WeekCalendarSingleDay.vue?vue&type=template&id=3165018b&scoped=true&"
import script from "./WeekCalendarSingleDay.vue?vue&type=script&lang=js&"
export * from "./WeekCalendarSingleDay.vue?vue&type=script&lang=js&"
import style0 from "./WeekCalendarSingleDay.vue?vue&type=style&index=0&id=3165018b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3165018b",
  null
  
)

export default component.exports